angular.module('bmsApp.settings').controller('CustomerGdprCleansingIndexCtrl', function(
    $state,
    $scope,
    ngTableParams,
    $ngBootbox,
    EmailSvc,
    CustomerSvc,
    $cookies,
    InstanceSvc,
    notify,
    $localStorage) {

    $scope.loading = true;
    $scope.updating = true;
    $scope.ecomEnabled = InstanceSvc.instance.ecomEnabled();

    var defaultCustomerParams = function() {
        return {
            page: 1, // show first page
            count: $scope.config.table.params.count, // count per page
            sorting: {
                surname: 'asc' // initial sorting
            },
            filter: {
                search: '',
                ready_for_cleansing: 1,
            }
        };
    };

    let initialCustomerParams = function() {
        if (angular.isDefined($localStorage.customerCleansingIndexParams)) {
            return angular.extend({}, defaultCustomerParams(), $localStorage.customerCleansingIndexParams);
        } else {
            return angular.extend({}, defaultCustomerParams());
        }
    };

    let params = initialCustomerParams();

    // copy the filters to a workable state
    $scope.customerFilters = angular.copy(params.filter);

    $scope.tableParams = new ngTableParams(params, {
        total: 0, // length of data
        counts: $scope.config.table.settings.counts, // available page counts
        getData: function($defer, params) {
            $scope.updating = true;
            $localStorage.customerCleansingIndexParams = params.$params;
            CustomerSvc.index(params.$params)
                .then(function(response) {
                    params.total(response.data.customer_filtered_count);
                    $defer.resolve(response.data.customer_collection);
                    $scope.$emit('customerIndexUpdated', {
                        customer_collection: response.data.customer_collection,
                        customer_filtered_count: response.data.customer_filtered_count,
                        customer_total_count: response.data.customer_total_count
                    });
                    $scope.customer_filtered_count = response.data.customer_filtered_count;
                    $scope.customer_total_count = response.data.customer_total_count;

                    // Check if we've exceeded our page size, if we have, go back
                    if (response.data.customer_filtered_count > 0 && !response.data.customer_collection.length) {
                        let newParams = angular.copy($scope.tableParams.$params);
                        newParams.page--;
                        angular.extend($scope.tableParams.$params, newParams);
                    }
                    $scope.updating = false;
                    $scope.loading = false;
                });
        }
    });

    // Store the table params whenever anything changes
    $scope.$watch('tableParams.$params', function(value) {
        if (angular.isObject(value)) {
            $cookies.customerCleansingIndexParams = JSON.stringify(value);
        }
    }, true);

    // update text search without having to click apply
    $scope.filterChanged = function() {
        $scope.tableParams.$params.filter.search = $scope.customerFilters.search;
    };


    $scope.rowClicked = function(customer) {
        customer.selected_for_cleansing = !customer.selected_for_cleansing;
    };

    $scope.all_selected = false;
    $scope.all_select_deselect_toggle_btn_label = 'Select All';

    $scope.selectOrDeselectAll = function() {
        angular.forEach($scope.tableParams.data, function(customer, key) {

            if (!$scope.all_selected) {
                customer.selected_for_cleansing = true;
            } else {
                customer.selected_for_cleansing = false;
            }
        })
        $scope.all_selected = !$scope.all_selected;
        $scope.all_select_deselect_toggle_btn_label = $scope.all_selected ? 'Deselect All' : 'Select All';
    }

    $scope.toggleSelection = function() {
        angular.forEach($scope.tableParams.data, function(customer, key) {
            customer.selected_for_cleansing = !customer.selected_for_cleansing;
        })
    }

    $scope.cleanseSelected = function() {
        if (!$scope.oneOrMoreCustomerSelected()) {
            return;
        }


        $ngBootbox.confirm('Are you sure you want to cleanse the selected customers?')
            .then(function () {
                $scope.loading = true;
                CustomerSvc.gdprCleansing({
                        'selected_ids': $scope.selectedIds,
                    })
                    .then(function(response) {
                        $scope.loading = false;
                        notify({
                            message: 'Selected customers cleansed successfully'
                        });
                        $scope.selectedIds = [];
                        $scope.tableParams.reload();
                        $scope.all_selected = false;
                        $scope.all_select_deselect_toggle_btn_label = 'Select All';

                    });
            });
    };

    $scope.keepSelected = function() {
        if (!$scope.oneOrMoreCustomerSelected()) {
            return;
        }

        $ngBootbox.confirm('Are you sure you want to postpone the cleansing of these selected customers for 12 months?')
            .then(function () {
                $scope.loading = true;
                CustomerSvc.postponeGdprCleansing({
                        'selected_ids': $scope.selectedIds,
                    })
                    .then(function(response) {
                        $scope.loading = false;
                        notify({
                            message: 'Selected customers kept for a further 12 months'
                        });
                        $scope.selectedIds = [];
                        $scope.tableParams.reload();
                        $scope.all_selected = false;
                        $scope.all_select_deselect_toggle_btn_label = 'Select All';
                    });
            });
    };

    $scope.oneOrMoreCustomerSelected = function() {
        $scope.selectedIds = [];
        angular.forEach($scope.tableParams.data, function(customer, key) {
            if (customer.selected_for_cleansing == true) {
                $scope.selectedIds.push(customer.id);
            };
        });
        if ($scope.selectedIds.length == 0) {
            notify({
                message: 'Please select one or more customers',
                classes: 'error',
            });
            return false;
        }
        return true;

    };

});
